import { call, put } from "redux-saga/effects";
//import { HOME } from "../../../apis/appUrls";
import {
  forgotPasswordRequest,
  loginRequest,
  logout,
  refreshTokenRequest,
  send2FAEmail,
} from "../../../apis/common";
import { history } from "../../../history";
import {
  forgotPasswordError,
  forgotPasswordSuccess,
  loginError,
  loginSuccess,
  logoutError,
  logoutSuccess,
  refreshTokenError,
  refreshTokenSuccess,
  emailSend2FASuccess,
  emailSend2FAError,
} from "../../slices/authSlice";

export function* handleLogin(action) {
  const { email, password, userCode2FA } = action.payload;
  const responseData = yield call(loginRequest, {
    email,
    password,
    userCode2FA,
  });

  //console.log('auth responseData --->',responseData)

  if (
    responseData &&
    responseData.user_role === "OFFSITE" &&
    (responseData.status === "1" || responseData.status === 1)
  ) {
    
    yield put(loginSuccess({ ...responseData }));
    //console.log("history push called");
    // history.push("/select-dealership");
  } else if (
    responseData &&
    (responseData.status === "1" || responseData.status === 1)
  ) {
    yield put(loginSuccess({ ...responseData }));
    //console.log("history push called");
    // history.push("/select-location");
  } else if (
    responseData &&
    (responseData.status === "0" || responseData.status === 0)
  ) {
    console.log("invalid credentials", responseData.message);
    yield put(loginError({ message: responseData.message }));
  } else if (
    responseData &&
    (responseData.code === 401 || responseData.code === 400)
  ) {
    console.log("need to check invalid ...", responseData.message);
    yield put(loginError({ message: responseData.message }));
  } else {
    console.log("need to check ...", responseData.message);
    yield put(loginError({ message: "Something went wrong" }));
  }
}

export function* handleForgotPassword(action) {
  try {
    const { email } = action.payload;
    const responseData = yield call(forgotPasswordRequest, { email });
    if (responseData && responseData.code === 200) {
      yield put(forgotPasswordSuccess({ ...responseData }));
    }
  } catch (error) {
    if (error.response.status === 400) {
      yield put(forgotPasswordError({ message: error.response.data.message }));
    } else {
      yield put(forgotPasswordError({ message: "Something went wrong." }));
    }
    console.log(error);
  }
}

export function* handleRefreshToken(action) {
  try {
    const { refreshToken } = action.payload;
    const response = yield call(refreshTokenRequest, { refreshToken });
    const responseData = response.data;

    if (
      response &&
      response.status === 200 &&
      responseData &&
      responseData.status === 1
    ) {
      yield put(refreshTokenSuccess({ ...responseData }));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      yield put(refreshTokenError({ message: error.response.data.message }));
    } else {
      yield put(refreshTokenError({ message: "Something went wrong." }));
    }
  }
}

export function* handleLogout(action) {
  const { authToken } = action.payload;
  console.log("Logout authToken handleLogout", authToken);
  const responseData = yield call(logout, { authToken });

  //console.log('auth responseData --->',responseData)

  if (
    responseData &&
    (responseData.status === "1" || responseData.status === 1)
  ) {
    yield put(logoutSuccess({ ...responseData }));
    //console.log("history push called");
    // history.push("/select-location");
  } else {
    console.log("need to check ...", responseData.message);
    yield put(logoutError({ message: "Something went wrong" }));
  }
}

//Send email for 2FA
export function* handleSendEmail2FA(action) {
  console.log("handleSendEmail2FA");

  const { email } = action.payload;
  const responseData = yield call(send2FAEmail, { email });

  //console.log('auth responseData --->',responseData)

  if (
    responseData &&
    (responseData.status === "1" || responseData.status === 1)
  ) {
    yield put(emailSend2FASuccess({ ...responseData }));
    //console.log("history push called");
    //history.push("/select-location");
  } else if (
    responseData &&
    (responseData.status === "0" || responseData.status === 0)
  ) {
    console.log("invalid email for 2FA", responseData.message);
    yield put(emailSend2FAError({ message: responseData.message }));
  } else if (
    responseData &&
    (responseData.code === 401 || responseData.code === 400)
  ) {
    console.log("need to check invalid email...", responseData.message);
    yield put(emailSend2FAError({ message: responseData.message }));
  } else {
    console.log("need to check 2FA...", responseData.message);
    yield put(emailSend2FAError({ message: "Something went wrong" }));
  }
}
